import { api } from '../client';

export type ApprovalStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface Approval {
  id: string;
  entityType: string;
  entityId: string;
  purchaseOrderId?: string;
  purchaseOrder?: {
    id: string;
    poNumber: string;
    totalAmount?: number;
    supplier?: { id: string; name: string };
  };
  requesterId: string;
  approverId?: string;
  approver?: { id: string; fullName: string; email: string };
  status: ApprovalStatus;
  comments?: string;
  requestedAt: string;
  respondedAt?: string;
}

export interface QueryApprovalParams {
  status?: ApprovalStatus;
  entityType?: string;
  requesterId?: string;
  approverId?: string;
  page?: number;
  limit?: number;
}

export const approvalsApi = {
  async getAll(params?: QueryApprovalParams) {
    const response = await api.get<{
      data: Approval[];
      meta: { total: number; page: number; limit: number; totalPages: number };
    }>('/api/approvals', { params });
    return response.data;
  },

  async getPendingCount() {
    const response = await api.get<number>('/api/approvals/pending/count');
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get<Approval>(`/api/approvals/${id}`);
    return response.data;
  },

  async decide(id: string, decision: 'APPROVED' | 'REJECTED', comments?: string) {
    const response = await api.post<Approval>(`/api/approvals/${id}/decide`, {
      decision,
      comments,
    });
    return response.data;
  },
};
